import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../shared/Header';
import Footer from '../common/Footer';
import VerveChatWidget from '../chat/VerveChatWidget';

/**
 * Layout for public-facing pages
 * Includes the Landing Header, footer, and the Model Armor-shielded Verve AI Concierge widget
 */
const PublicLayout = () => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
                <Outlet />
            </Box>
            <Footer />
            <VerveChatWidget />
        </Box>
    );
};

export default PublicLayout;
